import {
    Container,
    Paper,
    Typography,
    Box,
    Button
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import btnStyles from '../../styles/buttons.module.scss';
export default function SubmissionSuccess({

    onReturn

}) {

    return (

        <Box
            sx={{
                minHeight: "70vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                px: 2
            }}
        >

            <Paper
                elevation={4}
                sx={{
                    maxWidth: 1200,
                    width: "100%",
                    p: 5,
                    textAlign: "center",
                    borderRadius: 3
                }}
            >

                {/* Icon */}
                <CheckCircleIcon
                    sx={{
                        fontSize: 70,
                        color: "#2e7d32",
                        mb: 2
                    }}
                />

                {/* Title */}
                <Typography variant="h4" fontWeight={700} gutterBottom sx={{textAlign: "center"}}>
                    Thank You
                </Typography>

                {/* Message */}
                <Typography variant="body1" sx={{ textAlign: "center", mb: 3 }}>
                    Your New Starter Form has been submitted successfully.
                </Typography>
				<Typography

                    sx={{
                        textAlign: "center",
                        mb: 5
                    }}

                >

                    Your information has been received by Horbury Group.
                    The recruitment team will review your details and
                    contact you if any further information is required.

                </Typography>
                {/* Buttons */}
                <Box
                    sx={{
                        display: "flex",
                        gap: 2,
                        justifyContent: "center",
                        flexWrap: "wrap"
                    }}
                >

                    <Button
                        className={btnStyles.btnDesktop}
                        variant="contained"
                        size="large"
                        sx={{ textTransform: 'none' }}
                        onClick={onReturn}
                    >
                        Return to Home
                    </Button>

                </Box>

            </Paper>

        </Box>

    );

}